// useBooking.js
export function useFormatting() {
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('vi-VN', {style: 'currency', currency: 'VND'}).format(value)
    }

    const formatDateTime = (date) => {
        return new Date(date).toLocaleString('vi-VN', {
            hour: '2-digit',
            minute: '2-digit',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        })
    }

    const formatPaymentMethod = (gateway, method) => {
        const methods = {
            'moveek': {
                'bank-transfer': 'Chuyển khoản / Quét mã QR',
                'moveek-credits': 'Moveek Credits'
            },
            'momo': {
                '': 'Ví MoMo'
            },
            'payoo': {
                'cc': 'Thẻ ATM / Thẻ quốc tế'
            }
        }

        return methods[gateway]?.[method] || ''
    }

    return {
        formatCurrency,
        formatDateTime,
        formatPaymentMethod
    }
}